/**
 * Suppress ResizeObserver loop errors which are benign but disruptive in dev.
 * These errors are common when using UI libraries like Radix or shadcn/ui.
 */
export const initErrorSuppression = () => {
  if (typeof window === "undefined") return;

  const suppressResizeObserverError = (e) => {
    try {
      const message = e.message || (e.reason && e.reason.message) || "";
      if (
        typeof message === "string" &&
        (message.includes("ResizeObserver loop") ||
          message.includes("ResizeObserver limit") ||
          message.includes("ResizeObserver loop completed"))
      ) {
        console.warn("Caught and suppressed ResizeObserver error:", message);
        e.stopImmediatePropagation?.();
        e.stopPropagation?.();
        e.preventDefault?.();
        const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
        const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
        if (resizeObserverErr) resizeObserverErr.setAttribute('style', 'display: none');
        if (resizeObserverErrDiv) resizeObserverErrDiv.setAttribute('style', 'display: none');

        return true;
      }
    } catch (err) {
      // Ignore errors in the error handler
    }
    return false;
  };

  window.addEventListener("error", suppressResizeObserverError);
  window.addEventListener("unhandledrejection", suppressResizeObserverError);

  // Old school fallback for older browsers or specific environments
  const originalOnError = window.onerror;
  window.onerror = (message, source, lineno, colno, error) => {
    if (typeof message === "string" && (message.includes("ResizeObserver loop") || message.includes("ResizeObserver limit"))) {
      return true;
    }
    return originalOnError?.(message, source, lineno, colno, error);
  };
};
